export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/56fd9a2f46c952e58b27363542ba1460.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Understand Your Body.<br />Decode Your Symptoms.
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-4 leading-relaxed">
            Know When You're Fertile—In Just 7 Days
          </p>
          <p className="text-lg md:text-xl text-white/90 mb-10 max-w-3xl mx-auto leading-relaxed">
            The Cycle Clarity Starter Kit empowers you to take control of your fertility journey with simple, science-backed methods to track your cycle naturally.
          </p>

          {/* Product Image */}
          <div className="mb-10 flex justify-center">
            <img
              src="https://static.readdy.ai/image/af84490e484a32258481d5416d7d609f/a1f6b33df07cbe56d141f27aecbd14ac.png"
              alt="Cycle Clarity Starter Kit Book"
              className="w-auto h-96 object-contain drop-shadow-2xl"
            />
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://payhip.com/b/EvcbM"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-violet-600 text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-violet-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Get Your Kit Now
            </a>
            <a
              href="https://youtu.be/5WB0IZXrPNc?si=VsGvEyUz3uhqreUc"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white/95 text-violet-700 px-10 py-4 rounded-full text-lg font-semibold hover:bg-white transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              Watch Video
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap items-center justify-center gap-8 text-white/90">
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-violet-400 text-xl"></i>
              <span className="text-sm font-medium">Science-Backed Methods</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-violet-400 text-xl"></i>
              <span className="text-sm font-medium">Easy to Follow</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-checkbox-circle-fill text-violet-400 text-xl"></i>
              <span className="text-sm font-medium">Results in 7 Days</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}